export default 
`Alex's language skills:
- german [native speaker]
- english [C2]
- french [A2]
- Typescript, Javascript, Java, Bash, Lua, PHP, C# and some more
`